import React, { useEffect, useRef } from "react";

const AutoResizeTextArea = ({
  value,
  onChange,
  id,
  className,
  wrap,
  autoComplete,
  placeholder,
  name,
  title,
  tile_name,
  handleChange,
}) => {
  const textAreaRef = useRef(null);

  const adjustHeight = () => {
    if (textAreaRef.current) {
      textAreaRef.current.style.height = "auto"; // Reset height
      textAreaRef.current.style.height = `${textAreaRef.current.scrollHeight}px`; // Set to new height
    }
  };

  useEffect(() => {
    adjustHeight();
  });

  return (
    <textarea
      id={id}
      ref={textAreaRef}
      value={value}
      name={name}
      title={title && title}
      onChange={(e) => {
        if (title === "description") {
          handleChange(e, tile_name);
        } else {
          onChange(e);
        }
      }}
      style={{
        resize: "none",
      }}
      className={className}
      placeholder={placeholder}
      wrap={wrap}
      autoComplete={autoComplete}
    />
  );
};

export default AutoResizeTextArea;
